<template>
  <v-card flat>
    <v-card-title>
      <h4 class="earth-color">ALL ACTIVITIES & ITEMS</h4>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        text="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="activeInventory"
      :search="search"
      :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
    >
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="fancy">{{ formated_date_time(props.item.created_at)}}</td>
        <td class="fancy">{{ props.item.code}}</td>
        <td class="fancy">{{ props.item.analysis_code}}</td>
        <td class="fancy">{{ props.item.sub_code}}</td>
        <td class="fancy">{{ props.item.google_analytics_code}}</td>
        <td class="fancy">{{ props.item.facebook_tag}}</td>
        <td class="fancy">{{ props.item.name}}</td>
        <td class="fancy">{{ props.item.maximum_guests}} </td>
        
        <td class="has-text-right">
          <v-btn :depressed="true" small v-on:click="viewUser(props.item.public_id)">View Details</v-btn>
          <v-btn :depressed="true" small v-if="route === 'ActiveInventory'" v-on:click="makeInactive(props.item.public_id)">Make Inactive</v-btn>
        </td>
      </template>
      <template slot="footer">
        <td :colspan="columns.length">
          <vue-json-to-csv
            :json-data="activeInventory"
            csv-title="Activities Items List"
            :labels="{
              name: { title: 'Service Name'},
              code: { title: 'Income Account Code'},
              analysis_code: { title: 'Analysis Code'},
              sub_code: { title: 'Outlet Code'},
              google_analytics_code: { title: 'Google Analytics Code'},
              maximum_guests: { title: 'Maximum Guests'},
              pricing_status: { title: 'Pricing Status'},
              vat: { title: 'Vat'},
              categing_levy: { title: 'Catering Levy'},
              ranger_marker: { title: 'Ranger Marker'},
              discount_status: { title: 'Discount Status'},
            }"
          >
            <v-btn class="">
              <b>Download CSV</b>
            </v-btn>
          </vue-json-to-csv>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv'
export default {
  components: { VueJsonToCsv },
  data () {
    return {
      search: '',
      route: this.$route.name,
      columns: [
        {
          text: 'Created on',
          value: 'created_at'
        },
        {
          text: 'Income Account Code',
          value: 'code'
        },
        {
          text: 'Department Code',
          value: 'analysis_code'
        },
        {
          text: 'Outlet Code',
          value: 'sub_code'
        },
        {
          text: 'Google Analytics Code',
          value: 'google_analytics_code'
        },
        {
          text: 'Facebook Conversion Tag',
          value: 'facebook_tag'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Maximum Guests',
          value: 'maximum_guests'
        },
        {
          text: 'Pricing Set',
          value: 'pricing_status'
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_active_activities')
  },
  methods: {
    getPricingStatus (status) {
      if (status === 'false') {
        return 'Not Set'
      } else {
        return 'Set'
      }
    },
    makeInactive: function (publicId) {
      this.$store.dispatch('make_activity_inactive', publicId)
    },
    viewUser: function (publicId) {
      this.$router.push({
        name: 'SingleInventory',
        params: {
          inventory_id: publicId
        }
      })
    }
  }
}
</script>

<style>

</style>
